<template>
  <section class="sof-card">
    <label class="sof-card__row">
      <v-checkbox
        v-model="mitVersicherungSofort"
        color="primary"
        density="comfortable"
        hide-details
        class="sof-card__check"
      />
      <div class="sof-card__main">
        <div v-if="tarif.tarif_sofort == 1" class="sof-card__title">
          Sofortversicherung Ihrer laufenden Behandlung
        </div>
        <div v-if="tarif.tarif_sofort == 2" class="sof-card__title">
          Sofortversicherung Implantate
        </div>

        <p v-if="tarif.tarif_sofort == 1" class="sof-card__sub">
          Für <strong>29,90&nbsp;€</strong> mtl. (24&nbsp;Monate Laufzeit)
          können Sie die Kosten Ihrer laufenden bzw. angeratenen Behandlung
          mitversichern.
          <a
            class="sof-card__link"
            @click.prevent="berechnungStore.setShowPop(tarif, 'sofortpop')"
          >
            Leistungsdetails →
          </a>
        </p>
        <p v-if="tarif.tarif_sofort == 2" class="sof-card__sub">
          Mit dem ZahnPRIVAT Premium der Union Krankenversicherung kann eine
          bereits angeratene Implantat-Versorgung gegen einen Risikozuschlag
          von <strong>8,60&nbsp;€</strong> je Zahn mitversichert werden.
          <a
            class="sof-card__link"
            @click.prevent="berechnungStore.setShowPop(tarif, 'sofortpop')"
          >
            Leistungsdetails →
          </a>
        </p>
      </div>
    </label>
  </section>
</template>

<script setup>
  import { ref, watch, defineProps, defineEmits } from "vue";
  import { useBerechnungStore } from "@/stores/berechnung";
  const berechnungStore = useBerechnungStore();
  const emit = defineEmits(["updatedMitversicherungSofort"]);
  const props = defineProps({
    tarif: { type: Object },
    berechnung: { type: Object },
  });
  const mitVersicherungSofort = ref(false);

  watch(mitVersicherungSofort, (newValue) => {
    emit("updatedMitversicherungSofort", newValue);
  });
  console.log(props.tarif);
</script>

<style scoped>
  .sof-card {
    background: #ffffff;
    border: 1px solid #d8dde5;
    border-left: 3px solid #f6a800;
    border-radius: 3px;
  }
  .sof-card__row {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 6px 14px;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    margin: 0;
  }
  .sof-card__check {
    flex: 0 0 auto;
  }
  .sof-card__check :deep(.v-selection-control) {
    min-height: auto;
  }
  .sof-card__check :deep(.v-icon) {
    font-size: 26px;
    opacity: 1;
  }
  .sof-card__main {
    min-width: 0;
  }
  .sof-card__title {
    font-size: 16px;
    font-weight: 700;
    color: #0f172a;
    line-height: 1.25;
  }
  .sof-card__sub {
    margin: 4px 0 0;
    font-size: 13.5px;
    color: #4b5563;
    line-height: 1.5;
  }
  .sof-card__link {
    color: #0f4c81;
    font-weight: 600;
    margin-left: 2px;
    cursor: pointer;
    text-decoration: none;
  }
  .sof-card__link:hover {
    text-decoration: underline;
  }

  @media (max-width: 720px) {
    .sof-card__row {
      gap: 6px 10px;
      padding: 10px 12px;
    }
  }
</style>
